import {Utils} from 'neo-common';

export class StatusBar {

    public static Types = {
        RTP: 'rtp',
        TOTAL_GAIN: 'totalGain',
        Message: 'message',
        MaxPayoutProbability: 'maxPayoutProbability',
        StatusBarMessage: 'statusBarMessage'
    };

    public static StatusBarHeight: number = 0;

    public static StatusBarWidth: number = 0;

    private static Instance: StatusBar;

    private static IdPrefix: string = 'StatusBar';

    private statusBarHolder: HTMLElement;

    //******************************************************************************************************************
    //  CONSTRUCTOR
    //******************************************************************************************************************

    public static getInstance(): StatusBar {
        if (Utils.isNullOrUndefined(StatusBar.Instance)) {
            StatusBar.Instance = new StatusBar();
        }

        return StatusBar.Instance;
    }

    constructor() {
        this.statusBarHolder = <HTMLDivElement>(document.createElement('div'));
        this.statusBarHolder.id = 'statusBar';
        this.statusBarHolder.classList.add('_disabled');
        document.body.appendChild(this.statusBarHolder);
    }

    //******************************************************************************************************************
    //  CONTROLS
    //******************************************************************************************************************

    public add(type: string, id: string, text: string, customData?: any): void {
        switch (type) {
            case StatusBar.Types.StatusBarMessage:
            case StatusBar.Types.Message:
                this.message(id, text, customData);
                break;
            case StatusBar.Types.RTP:
                this.rtp(id, text, customData);
                break;
            case StatusBar.Types.TOTAL_GAIN:
                this.totalGain(id, text, customData);
                break;
            case StatusBar.Types.MaxPayoutProbability:
                this.maxPayoutProbability(id, text, customData);
                break;
        }

        StatusBar.updateHeight();
    }

    public remove(id: string): void {
        if (this.hasElement(id)) {
            const elem = this.getElement(id);

            if (elem.parentElement != null) {
                elem.parentElement.removeChild(elem);
            }
        }

        StatusBar.updateHeight();
    }

    public hasActiveWidget(widgetId: string = null): boolean {
        if (widgetId == null) {
            return StatusBar.StatusBarHeight !== 0;
        }

        return this.hasElement(widgetId);
    }

    public static updateHeight(): void {
        const holder = document.getElementById('statusBar');

        if (holder != null) {
            const height = parseInt(window.getComputedStyle(holder, null).getPropertyValue('height')) +
                           parseInt(window.getComputedStyle(holder, null).getPropertyValue('padding-top'));

            StatusBar.StatusBarHeight = -height;
        }
    }

    //******************************************************************************************************************
    //  ADDONS
    //******************************************************************************************************************

    private message(id: string, text: string, customData?: any): void {
        const elem = this.getElement(id);
        elem.innerHTML = text;
        elem.setAttribute('style', 'text-align: center; flex: 1; order: 4');

        this.appendChild(elem);
    }

    private rtp(id: string, text: string, customData?: any): void {
        const elem = this.getElement(id);
        elem.innerHTML = text;
        elem.setAttribute('style', 'text-align: center; order: 1');

        this.appendChild(elem);
    }

    private totalGain(id: string, text: string, customData?: any): void {
        const elem = this.getElement(id);
        elem.innerHTML = text;
        elem.setAttribute('style', 'text-align: center; order: 3');

        this.appendChild(elem);
    }

    private maxPayoutProbability(id: string, text: string, customData?: any): void {
        const elem = this.getElement(id);
        elem.innerHTML = text;
        elem.setAttribute('style', 'text-align: center; order: 2');

        this.appendChild(elem);
    }

    //******************************************************************************************************************
    //  HELPER
    //******************************************************************************************************************

    private getElement(id: string): HTMLElement {
        id = id + StatusBar.IdPrefix;
        let elem = document.getElementById(id);

        if (elem == null) {
            elem = document.createElement('div');
            elem.setAttribute('id', id);
        }

        return elem;
    }

    private hasElement(id: string): boolean {
        id = id + StatusBar.IdPrefix;
        return document.getElementById(id) != null;
    }

    private appendChild(elem: HTMLElement): void {
        if (this.statusBarHolder != null) {
            if (!this.hasElement(elem.id)) {
                this.statusBarHolder.appendChild(elem);
            }

            this.statusBarHolder.classList.remove('_disabled');
        }
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Plugins/StatusBar/StatusBar.ts
 **/